/** Cria INSTÂNCIAS de equipamento a partir de uma definição + raridade (rola atributos). */
import { definitionById, poolFor } from "./Catalog";
import { rarityMult, secondaryCount } from "./Rarity";
import type { AttrKey, EquipmentInstance, Rarity, RolledAttr } from "./EquipmentTypes";
import { randRange } from "../utils/math";

let counter = 0;

/** Garante que os ids gerados não colidam com os de um save carregado. */
export function seedInstanceCounter(n: number): void {
  if (n > counter) counter = n;
}

function newId(): string {
  counter += 1;
  return `it_${counter}_${Math.floor(Math.random() * 1e6).toString(36)}`;
}

// 10.9EQ — BUG antigo (desde 10.5T): os atributos novos em FRACAO (dano/defesa por tipo, bloqueio,
// regeneracao) nao estavam aqui e caiam no `Math.max(1, Math.round(raw))` dos inteiros — TODO roll
// saia exatamente 1 (= 100%). Medido em 2.607 drops: regen e roubo de vida sempre 1,000. Um peitoral
// com "defesa cortante" dava +100% em vez de 3-9%. Agora toda fracao arredonda em 3 casas.
// 10.9J6 — MESMO BUG voltou pelos atributos "maxHpPct"/"damagePct" (adicionados na 10.9FR, depois
// desta lista existir): faltavam aqui, entao todo roll deles saia 100% (dobra vida/dano) em vez dos
// 3-8% do pool. Achado em auditoria — nunca tinha sido reportado por um jogador.
const PERCENT_ATTRS: ReadonlySet<AttrKey> = new Set([
  "attackSpeed", "critChance", "critDamage", "moveSpeed",
  "dmgSlash", "dmgPierce", "dmgBlunt", "defSlash", "defPierce", "defBlunt", "block", "regen", "lifesteal",
  "maxHpPct", "damagePct",
]);

// 10.9J7 — AUDITORIA: os atributos secundários FLAT (armor/maxHp/damage/attackRange — um número fixo,
// não uma %) usavam o MESMO range min/max pra qualquer tier do item. Um roll de "armadura +2 a +6"
// era até 3× o baseArmor de um elmo T1 (3), mas menos de 3% do baseArmor de um elmo T14 (456) — o
// secundário virava irrelevante bem antes do fim de jogo (os %-based, tipo defSlash/critChance, já
// eram proporcionais por natureza e não têm esse problema). `tierScale` cresce ~12%/tier, um
// crescimento BEM mais lento que o do stat base (~40%/tier) — o secundário continua "secundário",
// só não vira zero. Primeiro número; ajustar com feedback de jogo real.
const FLAT_ATTRS: ReadonlySet<AttrKey> = new Set(["armor", "maxHp", "damage", "attackRange"]);
function tierScale(tier: number): number {
  return 1 + Math.max(0, tier - 1) * 0.12;
}

function rollValue(key: AttrKey, min: number, max: number, mult: number, tierMult: number): number {
  const raw = randRange(min, max) * mult;
  if (PERCENT_ATTRS.has(key)) return Math.round(raw * 1000) / 1000; // fração (0.05) — já proporcional, sem tierMult
  if (key === "attackRange") return Math.round(raw * tierMult * 100) / 100;
  if (FLAT_ATTRS.has(key)) return Math.max(1, Math.round(raw * tierMult));
  return Math.max(1, Math.round(raw));
}

/** Cria uma instância. `level` default 1. */
export function createInstance(definitionId: string, rarity: Rarity, level = 1): EquipmentInstance | null {
  const def = definitionById(definitionId);
  if (!def) return null;
  const mult = rarityMult(rarity);
  const tierMult = tierScale((def as { tier?: number }).tier ?? 1);
  const pool = poolFor(def.slot);
  const n = Math.min(secondaryCount(rarity), pool.length);

  // escolhe n atributos distintos do pool (embaralhado)
  const idx = pool.map((_, i) => i);
  for (let i = idx.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [idx[i], idx[j]] = [idx[j], idx[i]];
  }
  const rolls: RolledAttr[] = [];
  for (let k = 0; k < n; k++) {
    const p = pool[idx[k]];
    rolls.push({ key: p.key, value: rollValue(p.key, p.min, p.max, mult, tierMult) });
  }

  return { instanceId: newId(), definitionId, slot: def.slot, rarity, level, rolls };
}
